import * as areaParameterApi from './areaParametersApi';
import * as areaParameterActions from './areaParameterActions';

export function addAreaParameter(areaParameter, cb) {
  return (dispatch) => {
    const areaParameterToAdd = {
      ...areaParameter,
      parameter: areaParameter.parameter.id,
    };
    areaParameterApi.addParameter(areaParameterToAdd).then((response) => {
      if (response && response.data) {
        const newAreaParam = {
          ...response.data,
          parameter: areaParameter.parameter,
        };
        dispatch(areaParameterActions.addAreaParameter(newAreaParam));
        cb();
      }
    });
  };
}

export function updateParameter(areaParameter, cb) {
  return (dispatch) => {
    const areaParameterToUpdate = {
      ...areaParameter,
      parameter: areaParameter.parameter.id,
    };
    areaParameterApi.updateParameter(areaParameterToUpdate).then((response) => {
      if (response && response.data) {
        dispatch(areaParameterActions.updateAreaParameter(response.data));
        cb();
      }
    });
  };
}

export function deleteParameter(areaParameter) {
  return (dispatch) => {
    areaParameterApi.deleteParameter(areaParameter).then((response) => {
      if (response) {
        dispatch(areaParameterActions.deleteAreaParameter(areaParameter));
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/areaParameters/areaParametersServices.js